import { color, extendTheme } from '@chakra-ui/react'

// example theme
const gruntTheme = extendTheme({
//  fonts: {
//     heading: `'Raleway', sans-serif`,
//     body: `'Raleway', sans-serif`,
//   },
  colors: {
    grunt1: 
    {
      50: '#f1fcfc',
      100: '#c0f1f4',
      200: '#84e4e9',
      300: '#2dd1da',
      400: '#22b2ba',
      500: '#1d979e',
      600: '#187b80',
      700: '#125f64',
      800: '#0f5053',
      900: '#0d4244'
    },
      grunt2: {
        50: '#e8f3ff',
        100: '#cfd8e3',
        200: '#b5bdcc',
        300: '#97a3b4',
        400: '#7b899d',
        500: '#626f84',
        600: '#4b5768',
        700: '#343e4b',
        800: '#1e2530',
        900: '#070c18',
      }
  },
  components: {
    Input: {
      defaultProps: {
        borderRadius: '5',
        bg: 'red',
      },
    },
    Table: {
      variants: {
        unstyled: {
          table: {
            borderCollapse: 'separate',
            borderSpacing: 0,
          },
          th: {
            fontSize: 'xs',
            textAlign: 'center',
            color: 'gray.600',       // tamno siva — promijeni u 'gray.700' ako trebaš tamniju
            bg: 'white',
            position: 'sticky',
            top: '0',
            zIndex: '5',
            /*borderTopWidth: '1px',
            borderTopColor: 'black',
            borderBottomWidth: '1px',
            borderBottomColor: 'black',*/
            boxShadow: 'inset 0 1px 0 black, inset 0 -1px 0 black',
          },
        },
      },
    },
  },
  
});

export default gruntTheme;